import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, Label, YAxis, Tooltip, Bar } from 'recharts';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import { unit } from 'mathjs';

var MockData = [{
  local_date: "2016-12-15T00:00:00.000Z",
  usage: 1245
}, {
  local_date: "2016-12-16T00:00:00.000Z",
  usage: 215
}, {
  local_date: "2016-12-17T00:00:00.000Z",
  usage: 489
}, {
  local_date: "2016-12-18T00:00:00.000Z",
  usage: 7854
}, {
  local_date: "2016-12-19T00:00:00.000Z",
  usage: 1456
}, {
  local_date: "2016-12-20T00:00:00.000Z",
  usage: 4875
}, {
  local_date: "2016-12-21T00:00:00.000Z",
  usage: 4858
}, {
  local_date: "2016-12-22T00:00:00.000Z",
  usage: 4895
}, {
  local_date: "2016-12-23T00:00:00.000Z",
  usage: 1245
}, {
  local_date: "2016-12-24T00:00:00.000Z",
  usage: 4256
}, {
  local_date: "2016-12-25T00:00:00.000Z",
  usage: 3256
}, {
  local_date: "2016-12-26T00:00:00.000Z",
  usage: 1245
}, {
  local_date: "2016-12-27T00:00:00.000Z",
  usage: 2457
}, {
  local_date: "2016-12-28T00:00:00.000Z",
  usage: 1245
}, {
  local_date: "2016-12-29T00:00:00.000Z",
  usage: 5476
}, {
  local_date: "2016-12-30T00:00:00.000Z",
  usage: 6589
}, {
  local_date: "2016-12-31T00:00:00.000Z",
  usage: 2145
}];

/**
 * Energy Units Utility Module
 */

/**
 * Automatically determines the best fit for energy units
 * @param {*} value the number in wh
 */

var determineBestUnit = function determineBestUnit(value) {
  var units = ["L", "kl", "ML", "GL", "TL"];
  var converted = units.map(function (u) {
    return {
      unit: u,
      value: unit(value, "L").to(u).toNumber()
    };
  });

  var _ref = converted.filter(function (e) {
    return e.value > 1 && e.value < 1000;
  })[0] || {},
      unit$1 = _ref.unit;

  return unit$1 ? unit$1 : "L";
};
/**
 * auto formats the energy value based on the best unit
 * @param {*} value the number in wh
 */

var autoFormatVolumeValue = function autoFormatVolumeValue(value) {
  var unit$1 = determineBestUnit(value);
  var num = unit(value, "L").to(unit$1).toJSON();
  return "".concat(parseFloat(num.value).toFixed(2).toLocaleString(), "  ").concat(num.unit);
};

var WaterGraph = function WaterGraph(_ref) {
  var data = _ref.data,
      color = _ref.color,
      aspectRatio = _ref.aspectRatio;
  return React.createElement("div", {
    className: "aspect-ratio aspect-ratio-".concat(aspectRatio)
  }, React.createElement("div", {
    className: "aspect-ratio-content"
  }, React.createElement(ResponsiveContainer, null, React.createElement(BarChart, {
    data: data,
    margin: {
      top: 5,
      right: 20,
      left: 35,
      bottom: 20
    }
  }, React.createElement(CartesianGrid, {
    strokeDasharray: "3 3"
  }), React.createElement(XAxis, {
    dataKey: "time",
    domain: ["dataMin", "dataMax"],
    interval: "preserveStartEnd",
    tickFormatter: function tickFormatter(data) {
      return format(parse(data), "h:mm A");
    }
  }, React.createElement(Label, {
    value: "Date / Time",
    position: "bottom"
  })), React.createElement(YAxis, {
    domain: ["auto", "auto"],
    tickFormatter: function tickFormatter(data) {
      return autoFormatVolumeValue(data);
    }
  }, React.createElement(Label, {
    value: "Water Usage",
    position: "left",
    angle: -90,
    offset: 15,
    style: {
      textAnchor: "middle"
    }
  })), React.createElement(Tooltip, {
    labelFormatter: function labelFormatter(v) {
      return format(parse(v), "DD/MM/YYYY h:mm A");
    },
    formatter: function formatter(value, name, props) {
      return [autoFormatVolumeValue(value), "Water Usage"];
    }
  }), React.createElement(Bar, {
    dataKey: "consumed",
    fill: color
  })))));
};

WaterGraph.propTypes = {
  data: PropTypes.array.isRequired,
  color: PropTypes.string.isRequired,
  aspectRatio: PropTypes.string.isRequired
};
WaterGraph.defaultProps = {
  data: MockData,
  color: "#3193d0",
  aspectRatio: "16by9"
};

export default WaterGraph;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/component-lib/components/WaterGraph/index.js
// module id = oXlU
// module chunks = 3